import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { TaskInterface } from '@shared/api';
import { environment } from '@shared/environments';
import { Observable, tap } from 'rxjs';
import { CustomEntityCollectionBaseService } from '../entity-collection-base.class';
import { EntityTypeEnum } from '../entity.interface';

@Injectable({
  providedIn: 'root',
})
export class TasksService extends CustomEntityCollectionBaseService<TaskInterface> {
  private readonly http = inject(HttpClient);

  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.Task, elementsFactory);
  }

  clearTasks(ids: string[]): Observable<unknown> {
    const idsForRequest = ids.map((id) => ({ guid: id }));

    this.removeManyFromCache(ids);

    return this.http
      .post(`${environment.apiHost}/tasks/clear`, {
        tasks: idsForRequest,
      })
      .pipe(tap(() => this.refresh()));
  }

  clearAllTasks(): Observable<unknown> {
    this.clearCache();

    return this.http
      .post(`${environment.apiHost}/tasks/clear-all`, {})
      .pipe(tap(() => this.refresh()));
  }
}
